import { render, staticRenderFns } from "./formedModalUpdate.vue?vue&type=template&id=24c65374&scoped=true"
import script from "./formedModalUpdate.vue?vue&type=script&lang=js"
export * from "./formedModalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c65374",
  null
  
)

export default component.exports